<template>
  <li class="flex items-center space-x-2">
    <lf-checkbox
      v-model="parameterState.enabled"
      :value="parameterState.enabled"
      :name="parameter.name"
      @change="updateParameter(parameter.type, 'enabled', $event)"
    />
    <span class="w-1/2 truncate text-headline">{{ parameter.name }}</span>
    <div
      v-if="parameter.type === WorkflowWebhookParameterType.Boolean"
      class="flex flex-1 items-center justify-end"
    >
      <lf-switch
        v-model="parameterState.value as boolean"
        class="w-fit-content !flex-none"
        :name="parameter.name"
        :value="parameterState.value"
        @toggle-changed="
          updateParameter(parameter.type, 'value', $event.toString())
        "
      />
    </div>
    <lf-input
      v-else
      :name="parameter.name"
      :value="parameter.value?.toString()"
      small-size
      :show-label="false"
      :placeholder="$t('COMMON.VALUE')"
      no-margin
      @key-released="
        updateParameter(
          parameter.type,
          'value',
          $event.toString().toLowerCase()
        )
      "
    />
  </li>
</template>
<script setup lang="ts">
import { ref } from "vue";

import { WorkflowWebhookParameterType } from "@/enums/workflows";
import { getWebhookParameterValue } from "@/helpers/workflow";

import LfCheckbox from "@/components/ui/inputs/LfCheckbox.vue";
import LfInput from "@/components/ui/inputs/LfInput.vue";
import LfSwitch from "@/components/ui/inputs/LfSwitch.vue";

import type { OptionalWorkflowWebhookParameter } from "@/models/workflows";

const emit = defineEmits<{
  "parameter:change": [OptionalWorkflowWebhookParameter];
}>();

const { parameter } = defineProps<{
  parameter: OptionalWorkflowWebhookParameter;
}>();

const parameterState = ref({
  ...parameter,
});

const updateParameter = (
  type: WorkflowWebhookParameterType,
  key: keyof OptionalWorkflowWebhookParameter,
  value: string
) => {
  const updatedValue =
    key === "enabled"
      ? parameterState.value.enabled
      : getWebhookParameterValue(type, value);
  emit("parameter:change", {
    ...parameter,
    [key]: updatedValue,
  });
};
</script>
